// extracted by mini-css-extract-plugin
export default {"tooltip":"style_tooltip__Gzn2m","bounce":"style_bounce__+c1kw"};